module.exports = __webpack_public_path__ + "media/images/nabor-25-2ee7771e3a3fe9b915298fa4b58a4d9a.jpg";